const HowItWorks = () => {
  const steps = [
    {
      num: '01',
      icon: '🗓️',
      title: 'Prep',
      description:
        'Pre-meeting skills sync your calendar on a cadence and draft an agenda for each meeting — so your day is lined up, and briefed, before it starts.',
    },
    {
      num: '02',
      icon: '🎙️',
      title: 'Capture',
      description:
        'Hit record on your machine — mic plus system audio, any meeting app. No bot joins, and the live transcript streams in on your own AssemblyAI key.',
    },
    {
      num: '03',
      icon: '🃏',
      title: 'Support',
      description:
        'Your in-meeting skills watch the conversation and surface cards as it needs them — and Claude answers mid-meeting questions from the transcript and your notes.',
    },
    {
      num: '04',
      icon: '🪪',
      title: 'Identify',
      description:
        'After the call, voice recognition names every speaker. You confirm who’s who once; the app remembers their voices for next time.',
    },
    {
      num: '05',
      icon: '📤',
      title: 'Deliver',
      description:
        'Claude writes the summary in your category’s note style, next steps open in claude.ai fully briefed, and a post-meeting skill ships notes to your tools via MCP.',
    },
  ];

  return (
    <section className="how" id="how-it-works">
      <div className="section-container">
        <p className="overline overline--center">HOW IT WORKS</p>
        <h2 className="section-title">From hello to handoff, on a machine you control</h2>
        <p className="section-subtitle">
          No cloud account, no bot, no pipeline to wire up. One desktop app carries the meeting
          from the first word to the follow-up work — and everything in between stays on your
          device.
        </p>

        <ol className="how-steps">
          {steps.map((s, i) => (
            <li key={i} className="how-step">
              <div className="how-step-num mono">{s.num}</div>
              <div className="how-step-icon" aria-hidden="true">
                {s.icon}
              </div>
              <h3>{s.title}</h3>
              <p>{s.description}</p>
              {i < steps.length - 1 && (
                <span className="how-step-arrow" aria-hidden="true">
                  →
                </span>
              )}
            </li>
          ))}
        </ol>

        <div className="how-loopback mono" aria-hidden="true">
          ⟲ and every meeting makes it sharper — voice recognition learns voices, skills learn your playbook
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
